import {
  ExperienceCategory,
  GetExperiencesListResponseBodyType,
} from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { experienceKeys } from "../queryKeys";

const getExperiencesList = async (options: {
  category: ExperienceCategory;
}) => {
  const resp = await api.get<GetExperiencesListResponseBodyType>(
    `/v2/experiences-list?category=${options.category}`
  );
  return resp.data;
};

export const useGetExperiencesList = ({
  category,
  options,
}: {
  category: ExperienceCategory;
  options?: QueryOptions<GetExperiencesListResponseBodyType, Error>;
}) => {
  return useQuery({
    ...options,
    queryKey:
      category === "experiment"
        ? experienceKeys.experimentList
        : experienceKeys.personalizationList,
    queryFn: async () => getExperiencesList({ category }),
  });
};
